import React from "react";
import { Route, Routes } from "react-router-dom";
import EnquiryFormPage from "../../Container/Website/EnquiryFormPage";

const LeadGenerationRoutes = () => {
  return (
    <div>
      <Routes>
        <Route path="/enquiry" element={<EnquiryFormPage/>} />
      </Routes>
    </div>
  );
};

export default LeadGenerationRoutes;
